import React from "react";
import { Helmet } from "react-helmet";
import "../notfound/notfound.scss"

const NotFound = () => {

    return (
        <div className="notFound">
            <Helmet>
                <title>ERROR 404 | wosgeat</title>
            </Helmet>
            <div className="container">
                <h2>404</h2>
                <h4>Hallo, wos geat?</h4>
                <p>
                    Jedoch ist diese Seite leider nicht mehr verfügbar oder du hast dich ganz einfach nur vertippt.
                </p>
            </div>
        </div>
    )
};

export default NotFound